import { render } from "./App.vue?vue&type=template&id=67f8de42&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=67f8de42&lang=scss"
import "./App.vue?vue&type=style&index=1&id=67f8de42&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f8de42"]])

export default __exports__